import { campaignTypes } from "./actions";

const initialState = {
  orgId: null,
  campaign_ticket_packages: [],
};

const campaignReducers = (state = initialState, action) => {
  switch (action.type) {
    case campaignTypes.CAMPAIGN_CLEAR:
      return { ...initialState };
    case campaignTypes.CAMPAIGN_FETCH_SUCCESS:
      return {
        ...state,
        ...action.data,
      };
    case campaignTypes.CAMPAIGN_FETCH_NOT_FOUND:
      return {
        ...state,
        error: true,
        notFound: true,
      };
    case campaignTypes.CAMPAIGN_PROGRESS_FETCH_SUCCESS:
      return {
        ...state,
        ...action.data,
      };
    case campaignTypes.CAMPAIGN_DONATION_GROUP_FETCH_SUCCESS:
      return {
        ...state,
        ...action.data,
      };
    case campaignTypes.CAMPAIGN_DATA_FETCH_SUCCESS:
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
};

export { campaignReducers };
